/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
const theme = {
    direction: 'ltr',
    palette: {
        common: {black: "#000", white: "#fff"},
        type: "light",
        primary: {
            main: "#222222",  
            contrastText: "#FF6600"
        },
        secondary: {
            main: "#dc004e", 
            contrastText: "#fff"
        },
        error: {
            main: "#f44336",
            contrastText: "#fff"
        },
        warning: {
            main: "#ff9800",
            contrastText: "rgba(0, 0, 0, 0.87)"
        },
        info: {
            main: "#2196f3", 
            contrastText: "#fff"
        },
        success: {
            main: "#4caf50", 
            contrastText: "rgba(0, 0, 0, 0.87)"
        },
        text: {
            primary: "rgba(0, 0, 0, 0.87)", 
            secondary: "rgba(0, 0, 0, 0.54)", 
            disabled: "rgba(0, 0, 0, 0.38)", 
            hint: "rgba(0, 0, 0, 0.38)"
        },
        divider: "rgba(0, 0, 0, 0.12)",
        background: {
            paper: "#ffffff", 
            default: "#f5f8fb"
        },
        action: {
            active: "rgba(0, 0, 0, 0.54)",
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: 0.04,
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: 0.08,
            disabled: "rgba(0, 0, 0, 0.26)",
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    },
    typography: {
        htmlFontSize: 16,
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontWeight: 800,
            fontSize: "3rem"
        },
        h2: {
            fontWeight: 500,
            fontSize: "2.5rem"
        },
        h3: {
            fontWeight: 500,
            fontSize: "2.25rem"
        },
        h4: {
            fontWeight: 800,
            fontSize: "1.75rem"
        },
        h5: {
            fontWeight: 500,
            fontSize: "1.5rem"
        },
        h6: {
            fontWeight: 800,
            fontSize: "1.25rem"
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: "1rem"
        },
        subtitle2: {
            fontWeight: 500,
            fontSize: "0.875rem"
        },
        body1: {
            fontWeight: 400,
            fontSize: "1rem"
        },
        body2: {
            fontWeight: 400,
            fontSize: "0.875rem"
        },
        button: {
            fontWeight: 500,
            fontSize: "0.875rem",
            textTransform: "uppercase"
        },
        caption: {
            fontWeight: 400,
            fontSize: "0.75rem"
        },
        overline: {
            fontWeight: 400,
            fontSize: "0.75rem",
            textTransform: "uppercase"
        }
    },
    spacing: 4
}

export default theme